var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlemayor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.75 106.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#68d1d1;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.04,1c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5H13.46c.9,0,1.73,.37,2.32,.97,.6,.6,.97,1.42,.97,2.32V100.91c0,.9-.37,1.72-.97,2.32-.6,.6-1.42,.97-2.32,.97H1.04c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5H13.46c.63,0,1.2-.26,1.62-.67,.42-.42,.67-.99,.67-1.62V3.29c0-.63-.26-1.2-.67-1.62-.41-.41-.99-.67-1.62-.67H1.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.68,101.17c.23-.15,.54-.07,.69,.16s.07,.54-.16,.69l-2.84,1.76,2.83,1.7c.24,.14,.31,.45,.17,.68-.14,.24-.45,.31-.68,.17l-2.71-1.62-.36-.21c-.41-.23-.62-.35-.62-.71,0-.36,.2-.48,.62-.73l.34-.21,2.72-1.69h0Zm-2.67,2.57v-.02l-.02,.06v.06l.02-.03v-.06Zm0,0s-.01-.03-.01-.02v.02h.01Zm-.01,.1s0,0,.02-.03l-.02,.03Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlemayor);
export default __webpack_public_path__ + "static/media/flemayor.8d9584edf50f55de7f2440a2a922645c.svg";
export { ForwardRef as ReactComponent };